import { render, staticRenderFns } from "./QBreadcrumbs.vue?vue&type=template&id=51c4f2ae&"
import script from "./QBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./QBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports